import React from "react";
import { useLang } from "../i18n";

export default function DeploymentSwitch({ checked, disabled, name, onChange, required = false }) {
  const { t } = useLang();
  return <div className="deployment-control">
    <button type="button" role="switch" aria-checked={checked} aria-label={t("deploy.label", { name })}
      className="deployment-switch" disabled={disabled || required} onClick={() => onChange(!checked)}
      title={required ? t("deploy.required") : t(checked ? "deploy.onHint" : "deploy.offHint")}>
      <span className="deployment-track" aria-hidden="true"><span className="deployment-thumb">
        <svg viewBox="0 0 16 16" className="deployment-check"><path d="m3 8 3 3 7-7" /></svg>
        <span className="deployment-off-mark" />
      </span></span>
      <span className="deployment-caption">{t(checked ? "deploy.on" : "deploy.off")}</span>
    </button>
    {required && <span className="deployment-state">{t("deploy.requiredShort")}</span>}
  </div>;
}
